import { render, staticRenderFns } from "./SsoCreateProfile.vue?vue&type=template&id=2d0d9d7e&scoped=true&"
import script from "./SsoCreateProfile.vue?vue&type=script&lang=js&"
export * from "./SsoCreateProfile.vue?vue&type=script&lang=js&"
import style0 from "./SsoCreateProfile.vue?vue&type=style&index=0&id=2d0d9d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0d9d7e",
  null
  
)

export default component.exports